import { RepoList } from "../../types/repositoryes";

export type RepositoryFilterMode = "all" | "favorites";
export type RepositorySortMode = "favorites" | "nameAsc" | "updatedDesc";

export interface RepositoryViewModel {
  id: string;
  owner: string;
  ownerUrl: string;
  name: string;
  description: string | null;
  avatar: string | null;
  repoUrl: string;
  isFavorite: boolean;
  updatedAt?: string;
  searchIndex: string;
}

export interface RepositoryToolbarState {
  query: string;
  filter: RepositoryFilterMode;
  owner: string;
  sort: RepositorySortMode;
}

export const toRepositoryViewModel = (repo: RepoList): RepositoryViewModel => ({
  id: `${repo.owner}/${repo.name}`,
  owner: repo.owner,
  ownerUrl: repo.ownerUrl,
  name: repo.name,
  description: repo.description,
  avatar: repo.avatar,
  repoUrl: repo.repoUrl,
  isFavorite: !!repo.isFavorite,
  updatedAt: (repo as RepoList & { updatedAt?: string }).updatedAt,
  searchIndex: `${repo.owner} ${repo.name} ${repo.description || ""}`.toLowerCase(),
});
